export default {
  /**
   * AR-2735 when page is translated via Google translate, the links need to remain relative to the subdomain of
   * translate.goog
   */
  mounted () {
    if (!location.host.includes('.translate.goog')) {
      return
    }
    this.$el.querySelectorAll('a[href^="/Atlas"]')
      .forEach(anchor => {
        const params = new URLSearchParams(anchor.search)
        for (const [key, value] of Object.entries(this.$route.query)) {
          params.append(key, value)
        }
        anchor.href = `${location.origin}${anchor.pathname}?${params.toString()}`
      })
  }
}
